import React from 'react';
import {FieldProp} from '../../types';
import {Text} from './Text';

type PasswordProps = FieldProp & {};

export const Password: React.FunctionComponent<PasswordProps> = (props): JSX.Element => {
    return (
        <Text {...props} type="password" />
    );
};